import Repository from "../../repository";

export default {
    GetView: (payload) => Repository.post(`/api/CameraRight/GetView`, payload),
    GetEdit: (payload) => Repository.post(`/api/CameraRight/GetEdit`, payload),
    Edit: (payload) => Repository.post(`/api/CameraRight/Edit`, payload),
}

